import type { PageLoad } from './$types'
export const load: PageLoad = async ({ params }) => {
	const title = `Profile | Airheart`
	const description = `Your marketplace for digital travel guides`

	return {
		username: params.slug,
		title,
		description,
		requiresAuthentication: false,
		blockBanner: true,
		layoutType: 'itinerary',
	}
}
